// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__174S3","paramInput":"JobSimulator_paramInput__235wQ","input":"JobSimulator_input__2VCcH"};